import { SectionContainer, SectionContainerWrapper } from "../../library/utilities/SectionContainer";
import React, { useEffect, useState } from "react";
import { IntroductionSection } from "../components/IntroductionSection";
import { FirstQuestionSection } from "../components/FirstQuestionSection";
import styled from "styled-components";
import { ColorGrayscale } from "../../library/utilities/variables";
import { IntroBackgroundLayer } from "../components/IntroBackgroundLayer";
const IntroSection = styled(SectionContainer) `
    overflow: hidden;

    transition: all 300ms ease-in-out;
`;
const IntroSectionWrapper = styled(SectionContainerWrapper) `
    position: relative;
    z-index: 0;
`;
export function IntroPage({ question, comesFromBacktracking, onFirstQuestionAnswered, changeBackgroundColor }) {
    const [started, setStarted] = useState(false);
    useEffect(() => {
        changeBackgroundColor(started ? ColorGrayscale.lightGrey : ColorGrayscale.white);
    }, [started]);
    useEffect(() => {
        if (comesFromBacktracking) {
            setStarted(true);
        }
    }, [comesFromBacktracking]);
    return (React.createElement(IntroSection, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: .3 } },
        React.createElement(IntroSectionWrapper, null,
            !started && (React.createElement(IntroductionSection, { key: "IntroductionSection", onQuizStarted: () => setStarted(true) })),
            started && (React.createElement(FirstQuestionSection, { key: "FirstQuestionSection", question: question, onQuestionAnswered: answer => onFirstQuestionAnswered(answer) })),
            React.createElement(IntroBackgroundLayer, { key: "IntroBackgroundLayer", secondStage: started }))));
}
